import React from "react";
import { FilterButton } from "./style";

interface IDashboardFIlterButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
}

const DashboardFilterButton = ({ children, onClick = () => {} }: IDashboardFIlterButtonProps) => (
  <FilterButton onClick={onClick} icon="fa-caret-down">
    {children}
  </FilterButton>
);

export default DashboardFilterButton;
